import { useMutation } from '@apollo/client';
import { CONNECTED_SOCIAL_ACCOUNTS } from 'api/auth/queries';
import { COMPLETE_FACEBOOK_AUTH } from 'api/social-media-connections/mutations';
import {
  CompleteFacebookAuth,
  CompleteFacebookAuthVariables,
} from 'api/social-media-connections/types/CompleteFacebookAuth';

export const useCompleteFacebookAuth = () => {
  return useMutation<CompleteFacebookAuth, CompleteFacebookAuthVariables>(
    COMPLETE_FACEBOOK_AUTH,
    {
      refetchQueries: [{ query: CONNECTED_SOCIAL_ACCOUNTS }],
      awaitRefetchQueries: true,
    }
  );
};
